import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Root } from "./root";
import "./styles.css";
import { AppErrorBoundary } from "./ui/AppErrorBoundary";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppErrorBoundary><Root /></AppErrorBoundary>
  </StrictMode>
);
